/**
 * Generates a unique correlation ID for tracing requests across frontend and backend.
 * Used primarily for PayPal deposit flow observability.
 */
export function generateCorrelationId() {
    return crypto.randomUUID();
}
